import IntroView from './IntroView';

export default IntroView;
